import { ReaderPermission } from 'api/data.types'
import type { User } from 'api/data.types'
import Acervo from './acervo'

export const isTrial = (user: User): boolean => {
  return hasTrialInContract(user) || isTrialDaysLeft(user)
}

export const hasAccessForLimitedTime = (user: User) => {
  const daysLeft = user.reader?.daysLeft

  return daysLeft !== null && daysLeft !== undefined
}

export const isFirstAccessTrial = (user: User): boolean => {
  return (
    isTrial(user) &&
    user.reader?.permissions === ReaderPermission.TRIAL_FIRST_ACCESS
  )
}

export const isExpired = (user: User): boolean => {
  return user.reader?.daysLeft === -1
}

export const hasTrialAcervo = (user: User): boolean => {
  return Acervo.isFreemium(user) || Acervo.isPublic(user)
}

export const hasTrialInContract = (user: User): boolean => {
  return user?.reader?.entity?.contractInfo?.type === 'trial'
}

const isTrialDaysLeft = (user: User): boolean => {
  return hasTrialAcervo(user) && hasAccessForLimitedTime(user)
}

const Trial = {
  isTrial,
  isFirstAccessTrial,
  isExpired,
  hasTrialAcervo,
  hasAccessForLimitedTime
}

export default Trial
